import clsx from "clsx";
import "./Message.scss";
import {IconInfoCircle, IconAlertCircle, IconCircleCheck, IconAlertTriangle} from "@tabler/icons-react";

export type MessageProps = {
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "error" | "success" | "warning";
  icon?: React.ReactNode;
  className?: string;
};

const defaultIcons = {
  primary: <IconInfoCircle />,
  secondary: <IconCircleCheck />,
  error: <IconAlertCircle />,
  success: <IconCircleCheck />,
  warning: <IconAlertTriangle />,
};

export const Message = ({
  children,
  variant = "primary",
  icon,
  className,
}: MessageProps) => {
  const displayIcon = icon !== undefined ? icon : defaultIcons[variant];

  return (
    <div className={clsx("message", variant, className)}>
      {displayIcon && <span className="message-icon">{displayIcon}</span>}
      <span className="message-content">{children}</span>
    </div>
  );
};
